export const onPreRouteUpdate = () => {
  document.body.scrollTop = 0;
};
